/**
 * buscadorServidor -- buscar en el servidor mientras la persona escribe, sin pedir de mas y sin pintar tarde.
 *
 * Es el patron que ya vivia dentro del picker de Presupuestos (PresupuestosView.abrirPicker): espera a que se deje
 * de teclear (300 ms) y descarta la respuesta que llega despues de una busqueda mas nueva (contador). Sale a un
 * modulo para que otras pantallas lo usen sin copiarlo (T169 pieza B: el insumo del movimiento manual de Compras
 * se busca en el servidor en vez de traer el catalogo entero, #35388/#35415).
 * Lo prueba scripts/check-buscador-servidor.mjs.
 *
 * @module presentation/shared/buscadorServidor
 */

/**
 * @param {{ buscar: (q: string) => Promise<any>, pintar: (resultado: any, q: string) => void, esperaMs?: number }} opts
 * @returns {{ teclear: (q: string) => void, ahora: (q: string) => Promise<void> }}
 *   teclear: espera esperaMs desde la ultima tecla y busca; ahora: busca ya (al abrir o al limpiar)
 */
export function crearBuscador({ buscar, pintar, esperaMs = 300 }) {
  let espera = null;
  let seq = 0;
  async function ahora(q) {
    clearTimeout(espera);
    const mio = ++seq;
    const resultado = await buscar(q);
    if (mio !== seq) return; // llego tarde: ya hay una busqueda mas nueva
    pintar(resultado, q);
  }
  function teclear(q) {
    clearTimeout(espera);
    espera = setTimeout(() => { ahora(q); }, esperaMs);
  }
  return { teclear, ahora };
}
